import { TableState, SeatState } from './PokerTable';

const mockGameState: TableState = {
  sessionId: 'abc',
  mySessionToken: 'abc',
  mySeatIndex: 3,
  tableId: 'abc',
  isDealer: true,
  createdAt: 1234,
  pot: 50,
  dealerSeatIndex: 3,
  smallBlindIndex: 4,
  bigBlindIndex: 6,
  communityCards: ['9C', 'KS', '3D'],
  seats: [
    {
      seatIndex: 0,
      state: SeatState.EMPTY,
      name: `Seat 1`,
      chips: 500,
      currentPot: 10,
      cards: ['2C', '3C'],
      // @ts-ignore
      mockImage: '/assets/sara.png',
    },
    {
      seatIndex: 1,
      state: SeatState.FOLDED,
      name: `Michael`,
      chips: 500,
      currentPot: 0,
      cards: ['FOLDED', 'FOLDED'],
      //handDescription: 'Straight Flush, 6c High',
    },
    {
      seatIndex: 2,
      state: SeatState.EMPTY,
      name: `Seat 3 some super long name`,
      chips: 500,
      currentPot: 10,
      cards: ['HIDDEN', 'HIDDEN'],
    },
    {
      seatIndex: 3,
      state: SeatState.ACTIVE,
      name: `Sara`,
      chips: 490,
      currentPot: 10,
      cards: ['AS', 'AD'],
    },
    {
      seatIndex: 4,
      state: SeatState.ACTIVE,
      name: `Michelle`,
      chips: 240,
      currentPot: 10,
      cards: ['HIDDEN', 'HIDDEN'],
    },
    {
      seatIndex: 5,
      state: SeatState.ACTIVE,
      name: `Seat 6`,
      chips: 500,
      currentPot: 0,
      cards: ['HIDDEN', 'HIDDEN'],
    },
    {
      seatIndex: 6,
      state: SeatState.FOLDED,
      name: `Raj`,
      chips: 500,
      currentPot: 0,
      cards: ['FOLDED', 'FOLDED'],
    },
    {
      seatIndex: 7,
      state: SeatState.ACTIVE,
      name: `Seat 8`,
      chips: 490,
      currentPot: 10,
      cards: ['HIDDEN', 'HIDDEN'],
    },
    {
      seatIndex: 8,
      state: SeatState.ACTIVE,
      name: `Hasaan`,
      chips: 490,
      currentPot: 10,
      cards: ['HIDDEN', 'HIDDEN'],
    },
    {
      seatIndex: 9,
      state: SeatState.ACTIVE,
      name: `Liz`,
      chips: 480,
      currentPot: 20,
      cards: ['HIDDEN', 'HIDDEN'],
    },
  ],
};

export default mockGameState;
